import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { IntroducingBrokerNetworkKey } from 'api/Clients/Types/IntroducingBroker'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const networkColumns: GridColumn[] = [
  {
    title: 'Sub-IB Account',
    field: IntroducingBrokerNetworkKey.subIBAccount,
    show: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td data-test='name-column'>
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: props.dataItem.introducingBroker.id,
                slug: 'details',
              }),
            }}
            target='_blank'
          >
            {props.dataItem.introducingBroker.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Multitier Level',
    field: IntroducingBrokerNetworkKey.level,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'IB Profile',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.commissionPlanGroup) {
        return <td />
      }
      return <td className='columns__content'>{props.dataItem.commissionPlanGroup.name}</td>
    },
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Number of Clients',
    field: IntroducingBrokerNetworkKey.numberOfClients,
    show: true,
    className: 'clients-table-columns__content',
    filter: 'text',
  },
]
